import React, { useEffect } from 'react';
import '../styles/Footer.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom'; // ✅ Import Link
import qrImage from '../assets/qr.png'; // Make sure this path is valid

const Footer = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <footer className="footer" data-aos="fade-up">
      <div className="footer-top" data-aos="fade-right">
        <div className="footer-left">
          <h2>Cut costs , not vibe</h2>
        </div>
        <div className="footer-right" data-aos="fade-left">
          <img src={qrImage} alt="QR Code" />
        </div>
      </div>

      <hr className="footer-divider" />

      <div className="footer-sections">
        <div className="footer-column" data-aos="zoom-in">
          <h4>Product</h4>
          <p>Shade App</p>
        </div>

        <div className="footer-column" data-aos="zoom-in">
          <h4>
            <Link to="/aboutus" id="tit" className="footer-link">About Us</Link>
          </h4>
          
          <Link to="/aboutus" className="footer-link">Our Vision</Link>
          <p>
            <Link to="/privacy" className="footer-link">Privacy and Policy</Link>
          </p>
        </div>

        <div className="footer-column" data-aos="zoom-in">
          <h4>
            <Link to="/contactus" id="tit" className="footer-link">Contact Us</Link>
          </h4>
          <p>
            For any enquiry or concerns, please reach out us at <br />
            <a href="mailto:theshadeapp@gmail.com">theshadeapp@gmail.com</a><br />
            For redressal of grievances, please refer to{' '}
            <Link to="/privacy" className="footer-link">Privacy policy</Link>
          </p>
        </div>

        <div className="footer-column" data-aos="zoom-in">
          <h4>Address</h4>
          <p>
            12C Bharathi Nagar,<br />
            GN Mills, Thudiyalur Road,<br />
            Coimbatore, Tamil Nadu,<br />
            India - 641029
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
